@for (command of commands; track command) {
    <div class="card">
        <div class="card-header">
            {{ command.displayName?.en != null ? command.displayName?.en : command.name }}
        </div>
        <div class="card-body">
            <app-properties [properties]="command?.request?.schema?.fields" [isCommand]="true" [changeMarkerActive]="false" (propertyChanged)="onPropertyChanged(properties.values)" #properties></app-properties>

            @if ((commandError || {})[command.name]) {
                <div class="form-text text-danger"><i class="fas fa-exclamation-circle"></i>{{ (commandError || {})[command.name] }}</div>
            }
        </div>
        <div class="card-footer">
            <div class="commands-card-footer-content-width" [ngbTooltip]="'commands.executeCommandHint' | translation | async" [disableTooltip]="!isSelectedAssetDisabled" placement="top">
                <button
                    (click)="executeCommand(command.name, properties.values)"
                    class="btn btn-primary"
                    appDisabledPermission="asset.execute"
                    [disabled]="isSelectedAssetDisabled || (isCommandExecuting || {})[command.name] || !isSetCommand"
                >
                    @if ((isCommandExecuting || {})[command.name]) {
                        <span class="spinner-border spinner-border-sm"></span>
                    }
                    {{ 'commands.actions.executeCommand' | translation | async }}
                </button>
            </div>
        </div>
    </div>
}
